import { LoyaltyProfile, useLoyaltyProfile } from '../components/LoyaltyProfile'

export default {
  name: 'MyProfile',
  components: { LoyaltyProfile },
  template: `
  <div class="loyalty-my-profile container no-padding-sm-down section-margin-bottom">
    <div class="grid">
      <div class="col-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2">
        <div class="loyalty-form__wrapper">
          <LoyaltyProfile :profile="profile" />
        </div>
      </div>
    </div>
  </div>
  `,
  props: {
    loyaltyId: Number,
  },
  setup (props, { emit }) {
    const { profile } = useLoyaltyProfile()
    return { profile }
  },
}
